module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/creditos/nomina/detalles/components/capacidad-pago/capacidad-pago.component.scss
// module id = ./src/app/creditos/nomina/detalles/components/capacidad-pago/capacidad-pago.component.scss
// module chunks = main